import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { http } from "utils/http";
export var createFetchMaster = function(param) {
    var actions = param.actions, config = param.config;
    return function() {
        return function() {
            var _ref = _async_to_generator(function(dispatch) {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch(actions.fetchData());
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                http(config)
                            ];
                        case 2:
                            result = _state.sent();
                            dispatch(actions.fetchDataSuccess(result.data));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            dispatch(actions.fetchDataFailure());
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
export var createFetchLogicPrototype = function(param) {
    var actions = param.actions, configFn = param.configFn, onError = param.onError;
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, id = _ref.id, payload = _ref.payload, queryParams = _ref.queryParams, modalObj = _ref.modalObj, setModalObj = _ref.setModalObj;
        return function() {
            var _ref = _async_to_generator(function(dispatch) {
                var accessToken, config, result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch(actions.fetchData());
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            accessToken = localStorage.getItem("accessToken");
                            config = configFn({
                                id: id,
                                payload: payload,
                                queryParams: queryParams
                            }, {
                                accessToken: accessToken,
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            });
                            return [
                                4,
                                http(config)
                            ];
                        case 2:
                            result = _state.sent();
                            dispatch(actions.fetchDataSuccess(result.data));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            if (typeof onError === "function") {
                                onError(error, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                });
                            }
                            dispatch(actions.fetchDataFailure());
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
